import { render, staticRenderFns } from "./TabText.vue?vue&type=template&id=075332ea&scoped=true&"
import script from "./TabText.vue?vue&type=script&lang=js&"
export * from "./TabText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075332ea",
  null
  
)

export default component.exports